import type { RegionsDataInterface } from '~/src/repositories/regions/regions.repository';

const initialRegion = { id: 0, name: '' };

export class GeolocationState {
    currentRegion: RegionsDataInterface = initialRegion;
    isShowGeolocationBlock: boolean = true;
}
